import { Action, ActionCreator } from 'redux';

/**
 * ThreadActions specifies _action creators_ (i.e. objects that describe
 * changes to the reducers) that are concerned with Threads and Messages
 */

export const LOAD_COLUMNS_CONFIG = '[Columns] Load Tabs';

export interface LoadColumnsConfigAction extends Action {
  columns: any;
}

export const loadColumns: ActionCreator<LoadColumnsConfigAction> =
  (tabArgs: any): LoadColumnsConfigAction => {
    const columns: any = Object.assign({}, tabArgs);
    return {
      type: LOAD_COLUMNS_CONFIG,
      columns: columns
    };
  };

export const ADD_COLUMNS_CONFIG = '[Columns] Add Columns Config';

export interface AddColumnsConfigAction extends Action {
  config: {
    name: string;
    value: any;
  };
}

export const addColumnsConfig: ActionCreator<AddColumnsConfigAction> =
  (config) => ({
    type: ADD_COLUMNS_CONFIG,
    config: config
  });


export const UPDATE_COLUMNS_CONFIG = '[Columns] Update Columns Config';

export interface UpdateColumnsConfigAction extends Action {
  config: {
    name: string;
    value: any;
  };
}

export const updateColumnsConfig: ActionCreator<UpdateColumnsConfigAction> =
  (config) => ({
    type: UPDATE_COLUMNS_CONFIG,
    config: config
  });




